import { registerBlockType } from '@wordpress/blocks';
import Edit from './edit';
import metadata from './block.json';

import './assets/editor.css';

const galleryIcon = (
    <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clip-path="url(#clip0_10678_1654)">
            <path
                d="M2.46094 20.625H13.6328C14.1016 21.3542 14.7005 21.9792 15.4297 22.5H2.5C1.79688 22.474 1.21094 22.2266 0.742188 21.7578C0.273438 21.2891 0.0260417 20.7031 0 20V11.25C0.0260417 10.5469 0.273438 9.96094 0.742188 9.49219C1.21094 9.02344 1.79688 8.77604 2.5 8.75H17.5C18.4635 8.80208 19.1927 9.21875 19.6875 10C19.6354 10 19.5833 10 19.5312 10C19.4792 10 19.4271 10 19.375 10C18.3333 10 17.3828 10.2083 16.5234 10.625H2.5C2.10938 10.651 1.90104 10.8594 1.875 11.25V20C1.90104 20.3906 2.10938 20.599 2.5 20.625H2.46094ZM17.1875 5.625C17.7604 5.67708 18.0729 5.98958 18.125 6.5625C18.0729 7.13542 17.7604 7.44792 17.1875 7.5H2.77344C2.51302 7.5 2.29167 7.40885 2.10938 7.22656C1.92708 7.04427 1.83594 6.82292 1.83594 6.5625C1.83594 6.30208 1.92708 6.08073 2.10938 5.89844C2.29167 5.71615 2.51302 5.625 2.77344 5.625H17.1875ZM15.3125 2.5C15.8854 2.55208 16.1979 2.86458 16.25 3.4375C16.1979 4.01042 15.8854 4.32292 15.3125 4.375H4.64844C4.38802 4.375 4.16667 4.28385 3.98438 4.10156C3.80208 3.91927 3.71094 3.69792 3.71094 3.4375C3.71094 3.17708 3.80208 2.95573 3.98438 2.77344C4.16667 2.59115 4.38802 2.5 4.64844 2.5H15.3125ZM13.75 16.875C13.8021 15.2865 14.349 13.9583 15.3906 12.8906C16.4583 11.849 17.7865 11.3021 19.375 11.25C20.9635 11.3021 22.2917 11.849 23.3594 12.8906C24.401 13.9583 24.9479 15.2865 25 16.875C24.9479 18.4635 24.401 19.7917 23.3594 20.8594C22.2917 21.901 20.9635 22.4479 19.375 22.5C17.7865 22.4479 16.4583 21.901 15.3906 20.8594C14.349 19.7917 13.8021 18.4635 13.75 16.875ZM20 14.3359C19.974 13.9714 19.7656 13.763 19.375 13.7109C18.9844 13.763 18.776 13.9714 18.75 14.3359V16.2109H16.875C16.4844 16.263 16.276 16.4714 16.25 16.8359C16.276 17.2266 16.4844 17.4349 16.875 17.4609H18.75V19.3359C18.776 19.7266 18.9844 19.9349 19.375 19.9609C19.7656 19.9349 19.974 19.7266 20 19.3359V17.4609H21.875C22.2656 17.4349 22.474 17.2266 22.5 16.8359C22.474 16.4714 22.2656 16.263 21.875 16.2109H20V14.3359Z"
                fill="#FD51EC"
            />
        </g>
        <defs>
            <clipPath id="clip0_10678_1654">
                <rect
                    width="24"
                    height="24"
                    fill="white"
                    transform="translate(0.5)"
                />
            </clipPath>
        </defs>
    </svg>
);

registerBlockType(metadata.name, {
    icon: galleryIcon,
    title: metadata.title,
    edit: Edit,
});
